import Nav, {MMNavItem} from "../MegaMenus/Nav";
import Button, {ILink} from "tbk-components/src/components/Button";
import cn from "classnames";
import React from "react";
import {IBaseElementProps} from "tbk-components/src/components/BasicElement";

export interface IMenuRendererProps extends IBaseElementProps {
	navs?: MMNavItem[];
	classes?: string[];
	navIcons?: boolean;
	ctaLink?: ILink;
	ctaTitle?: string;
	ctaNavPosition?: number;
}

let navMenuLoaded = false;
const MenuRenderer: React.FC<IMenuRendererProps> = ({
	navs,
	classes,
	navIcons,
	ctaLink,
	ctaTitle,
	ctaNavPosition,
}) => {
	const ctaRender =
		ctaLink?.href && ctaTitle ? (
			<div className="nav-item-cta nav-item-cta--full position-relative text-white">
				<h4 className="h5 text-white mb-4">{ctaTitle}</h4>
				<Button
					href={ctaLink.href}
					target={ctaLink.target}
					size="sm"
					type="primary"
					label={ctaLink.label}
				/>
			</div>
		) : ctaLink?.href ? (
			<Button
				href={ctaLink.href}
				target={ctaLink.target}
				size="sm"
				type="primary"
				label={ctaLink.label}
			/>
		) : null;

	const displayNavs = [...navs];

	const ctaNavRender = {
		children: ctaRender,
		classNames: ['nav-item-cta-list'],
	} as MMNavItem;

	const renderedCtaPosition =
		ctaNavPosition && ctaNavPosition <= navs.length
			? ctaNavPosition
			: navs.length;

	//This determines the position of where the CTA should show in the nav listing order.
	displayNavs.splice(renderedCtaPosition, 0, ctaNavRender);

	return (
		<div className={( classes
				? cn('menu-section__nav-listing w-100', ...classes)
				: 'menu-section__nav-listing w-100' )}
		>
			{displayNavs && (
				<div
					className={cn(
						'calian-mega-menus__navs',
						navIcons && 'calian-mega-menus__navs--icons',
					)}
				>
					<Nav
						navItems={displayNavs}
						collapseEnabled={false}
						dropdownEnabled={false}
					/>
				</div>
			)}
		</div>
	);
};
export default MenuRenderer;
